module.exports = __webpack_public_path__ + "f3a34e1626caf37b073b281933b9f867.pdf";